/* script */
//
//
//
//
//
//
//
//
//

// Utils
import { isFunction } from 'lodash';

// Mixins
import preview from './preview';

const __vue_script__ = {
    name: 'FontPreview',

    supports: ['font/ttf', 'font/woff', 'font/woff2', 'font/otf'],

    mixins: [preview],

    data() {
        return {
            uid: `preview-${this._uid}`,
            styleId: `preview-${this._uid}-style`,
            css: null,
            styleElement: null
        };
    },

    async mounted() {
        await this.$utils.dom.loadFontFace(this.docId, this.path);
        this.css = `#preview-${this._uid} .font {font-family: "${this.docId}";}`;

        const style = document.createElement('style');
        style.id = this.styleId;
        document.head.appendChild(style);
        style.appendChild(document.createTextNode(this.css));
        this.styleElement = style;
    },

    beforeDestroy() {
        if (this.styleElement && isFunction(this.styleElement.remove)) {
            this.styleElement.remove();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-preview",attrs:{"id":_vm.uid}},[(_vm.small)?_c('div',{staticClass:"font"},[_c('p',[_vm._v("Lorem ipsum 0123456789")])]):_c('div',{staticClass:"font"},[_c('p',[_vm._v("Fugiat duis ad in eiusmod minim. Consectetur duis voluptate eiusmod ad cillum. Deserunt dolore quis exercitation ex labore tempor elit id. Minim consequat exercitation eiusmod anim eu consectetur veniam ut commodo cupidatat anim sit deserunt. Consectetur ullamco do dolore eu do esse irure aute esse laboris tempor enim. Dolore enim qui ad quis velit exercitation consectetur ea. Eiusmod quis incididunt aute occaecat minim incididunt velit laboris dolore elit mollit exercitation nulla reprehenderit.")])]),_vm._t("default")],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FontPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__